import TheHeader from './components/layout/TheHeader';
import TheSubHeader from './components/layout/TheSubHeader';
import TheSidebar from './components/layout/TheSidebar';
import TheLoading from './components/layout/TheLoading';

import QuickFilters from './components/QuickFilters';
import SGrid from './components/SGrid';
import SGridHead from './components/SGridHead';
import SPopup from './components/SPopup';
import SPopupDialog from './components/SPopupDialog';
import SBtn from './components/SBtn';
import STextField from './components/STextField';
import SFlag from './components/SFlag';
import SIcon from './components/SIcon';
import FlagIcon from './components/FlagIcon';
import ActivityGrid from './components/ActivityGrid';
import FiltersPanel from './components/FiltersPanel';
import AppLink from './components/AppLink';
import ChosenFilters from './components/ChosenFilters';
import FilterItem from './components/FilterItem';
import RichSel from './components/RichSel';
import MultiSel from './components/MultiSel';
import HeadCell from './components/HeadCell';
import RecPlayer from './components/RecPlayer';
import AuthForm from './components/AuthForm';
import DropPanel from './components/DropPanel';
import TabLinks from './components/TabLinks';
import STextArea from './components/STextArea';
import FullAccessError from './components/FullAccessError';
import Calendar from './components/Calendar';
import DateRange from './components/DateRange';
import ItemsList from './components/ItemsList';
import PageTable from './components/PageTable';
//import VisitsTable from './components/VisitsTable';
import ToggleBtn from './components/ToggleBtn';
import TextLists from './components/TextLists';
import TextDefault from './components/TextDefault';
import DomainPicker from './components/DomainPicker';
import ResultsOptsPanel from './components/ResultsOptsPanel';
import ValDiff from './components/ValDiff';
import PeriodNavBtn from './components/PeriodNavBtn';
import SiteLogo from './components/SiteLogo';
import ThemeSwitcher from './components/ThemeSwitcher';

import LineChart from './components/charts/LineChart';
import PieChart from './components/charts/PieChart';
import MapChart from './components/charts/MapChart';

Vue.component('the-header', TheHeader);
Vue.component('the-sub-header', TheSubHeader);
Vue.component('the-sidebar', TheSidebar);
Vue.component('quick-filters', QuickFilters);
Vue.component('s-grid', SGrid);
Vue.component('s-grid-head', SGridHead);
Vue.component('s-popup', SPopup);
Vue.component('s-popup-dialog', SPopupDialog);
Vue.component('s-btn', SBtn);
Vue.component('s-text-field', STextField);
Vue.component('s-flag', SFlag);
Vue.component('s-icon', SIcon);
Vue.component('flag-icon', FlagIcon);
Vue.component('activity-grid', ActivityGrid);
Vue.component('filters-panel', FiltersPanel);
Vue.component('app-link', AppLink);
Vue.component('chosen-filters', ChosenFilters);
Vue.component('filter-item', FilterItem);
Vue.component('rich-sel', RichSel);
Vue.component('multi-sel', MultiSel);
Vue.component('head-cell', HeadCell);
Vue.component('rec-player', RecPlayer);
Vue.component('auth-form', AuthForm);
Vue.component('drop-panel', DropPanel);
Vue.component('tab-links', TabLinks);
Vue.component('s-text-area', STextArea);
Vue.component('full-access-error', FullAccessError);
Vue.component('calendar', Calendar);
Vue.component('date-range', DateRange);
Vue.component('items-list', ItemsList);
Vue.component('page-table', PageTable);
//Vue.component('visits-table', VisitsTable);
Vue.component('toggle-btn', ToggleBtn);
Vue.component('text-lists', TextLists);
Vue.component('text-default', TextDefault);
Vue.component('domain-picker', DomainPicker);
Vue.component('results-opts-panel', ResultsOptsPanel);
Vue.component('the-loading', TheLoading);
Vue.component('val-diff', ValDiff);
Vue.component('period-nav-btn', PeriodNavBtn);
Vue.component('site-logo', SiteLogo);
Vue.component('theme-switcher', ThemeSwitcher);

Vue.component('line-chart', LineChart);
Vue.component('pie-chart', PieChart);
Vue.component('map-chart', MapChart);